import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.primary,
  '& .DSSubtitle': {
    color: theme.palette.text.secondary,
  },
  '& .DSHeader': {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(4),
    flexDirection: 'column',
    alignItems: 'flex-start',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
  },
  '& .DSButton': {
    flexShrink: 0,
  },
}));

export default StyledBox;
